import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './constants/languages';
import { TRANSLATION_NAMESPACES, DEFAULT_NAMESPACE } from './constants/namespaces';

const i18nConfig = {
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,
  defaultNS: DEFAULT_NAMESPACE,
  ns: TRANSLATION_NAMESPACES,
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },
  detection: {
    order: ['cookie', 'localStorage', 'navigator'],
    lookupCookie: 'i18next',
    caches: ['cookie', 'localStorage'],
  },
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  }
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(i18nConfig);

export default i18n;